module.exports = {"360423001":"豫宁街道","360423100":"新宁镇","360423101":"泉口镇","360423102":"鲁溪镇","360423103":"船滩镇","360423104":"澧溪镇","360423105":"罗坪镇","360423106":"石门楼镇","360423107":"宋溪镇","360423200":"大洞乡","360423201":"横路乡","360423202":"官莲乡","360423203":"巾口乡","360423204":"东林乡","360423205":"上汤乡","360423206":"甫田乡","360423207":"清江乡","360423208":"石渡乡","360423209":"杨洲乡","360423210":"罗溪乡","360423500":"万福经济技术开发区管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360423.json
// module id = 1381
// module chunks = 0